const doc = [({"zh_cn":({"adminConstantHotelCancelPolicyType":({"normal":"普通的", "primary":"优先"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;